"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var paho_mqtt_1 = require("../../clients/paho-mqtt");

var pb_1 = require("./pb");

var ExtendedStaffRoster =
/*#__PURE__*/
function (_pb_1$StaffRoster) {
  _inherits(ExtendedStaffRoster, _pb_1$StaffRoster);

  function ExtendedStaffRoster(properties) {
    var _this;

    _classCallCheck(this, ExtendedStaffRoster);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExtendedStaffRoster).call(this, properties));
    _this.type = ExtendedStaffRoster.type;
    return _this;
  }

  _createClass(ExtendedStaffRoster, [{
    key: "toMQTT",
    value: function toMQTT() {
      var topic = "".concat(this.staff).concat(ExtendedStaffRoster.context);
      var mqttMessage = new paho_mqtt_1.Message(ExtendedStaffRoster.encode(this).finish());
      mqttMessage.destinationName = topic;
      mqttMessage.qos = 1;
      mqttMessage.retained = true;
      return mqttMessage;
    }
  }], [{
    key: "fromMQTT",
    value: function fromMQTT(mqttMessage) {
      return new ExtendedStaffRoster(pb_1.StaffRoster.decode(mqttMessage.payloadBytes));
    }
  }]);

  return ExtendedStaffRoster;
}(pb_1.StaffRoster);

ExtendedStaffRoster.type = "StaffRoster";
ExtendedStaffRoster.context = "/roster";
exports.StaffRoster = ExtendedStaffRoster;